module.exports = __webpack_public_path__ + "img/headDetault.02a4f904.svg";